// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";

import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyBhegsz0ae0fr_nAUsB4KYpRw2vx6isGFw",
  authDomain: "astugna-d1d89.firebaseapp.com",
  projectId: "astugna-d1d89",
  storageBucket: "astugna-d1d89.firebasestorage.app",
  messagingSenderId: "69161614027",
  appId: "1:69161614027:web:c9106746dc647e133cb94e",
  measurementId: "G-GYB1S04DP6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);